import {
  BulkCustomEmailRequest,
  SeriesTestCustomEmailRequest,
  createAppbaseSendEmails,
  listEventMembers,
  sendCustomEmailEmail,
  sendSeriesTestEmail,
  sendTestEmailEmail
} from '@goldcast/api/backend';
import logger from '@goldcast/logger';

import { showSuccessNotification, showErrorNotification } from '@/utils/utils.js';

const actions = {
  async sendTestEmail(context, { payload, requestFor, id }) {
    if (context.state.loadingSendTestEmail) {
      return;
    }

    context.commit('setLoadingSendTestEmail', true);

    try {
      if (requestFor === 'series') {
        await sendSeriesTestEmail({
          series_id: id,
          body: payload as SeriesTestCustomEmailRequest
        });
      } else {
        await sendTestEmailEmail({
          body: payload as BulkCustomEmailRequest
        });
      }
      showSuccessNotification('Sent mail successfully');
    } catch (error) {
      const errorObject = JSON.parse(error as any);
      const errorCode = errorObject?.emails ? errorObject.emails[0]?.code : '';
      const errorMessage =
        errorCode === 'does_not_exist'
          ? 'Emails must be sent to a registered Goldcast user. Please try again.'
          : 'Sending test mail failed.';
      showErrorNotification(errorMessage);
      return error;
    } finally {
      context.commit('setLoadingSendTestEmail', false);
    }
  },
  async sendCustomEmail(context, body) {
    if (context.state.loadingSendEmail) {
      return;
    }

    context.commit('setLoadingSendEmail', true);
    try {
      const response = await sendCustomEmailEmail({ body });
      showSuccessNotification('Sent mail to registrants successfully');
      return response;
    } catch (error) {
      showErrorNotification('Sending mail failed.');
      return { error };
    } finally {
      context.commit('setLoadingSendEmail', false);
    }
  },
  sendAppbaseEmails(context, body) {
    if (context.state.loadingSendEmail) {
      return;
    }

    const event_id = context.rootGetters['studioEventList/getCurrentEvent']?.id;
    if (event_id) {
      context.commit('setLoadingSendEmail', true);
      return createAppbaseSendEmails({ id: event_id, body })
        .then(() => {
          showSuccessNotification('Sent mail to registrants successfully');
          context.commit('setLoadingSendEmail', false);
        })
        .catch(err => {
          logger.error('Error when sending email: ', err);
          context.commit('setLoadingSendEmail', false);
          showErrorNotification(err.message);
        });
    }
  },
  async fetchTotalRegistrants(context, eventId) {
    context.commit('setLoadingSendTestEmail', true);
    try {
      const response = await listEventMembers({ queryParams: { event: eventId, limit: 20, offset: 0 } });
      context.commit('setTotalRegistrants', response.count);
    } catch (error) {
      showErrorNotification('Error while fetching total registrants');
    } finally {
      context.commit('setLoadingSendTestEmail', false);
    }
  }
};

export default actions;
